
import React, {PureComponent} from 'react';
import './NavigationBar.scss';

export class NavigationBar extends PureComponent {

    render = () => {
        return (
            <nav className="navigation navigation-bar" {...this.props}>
                {this.props.children}
            </nav>
        );
    };
}



// WEBPACK FOOTER //
// /Users/stephan/skelware/savot/src/components/NavigationBar/NavigationBar.jsx